import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Header from '@components/layout/Header';
import { Footer } from '@components/layout/Footer';

export default function OurPartnersPage() {
  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <h1 className="flex flex-row justify-center text-[30px]">
        Our partners:
      </h1>
      <main className="flex-1 container pt-[65px]">
        {' '}
        <ul>
          <li>
            <a href={'https://theporndude.com/13370/aigirlfriendwtf/'}>
              ThePornDude.com + AI Girlfriend WTF
            </a>
          </li>
          <li>
            <a href={'https://thepornlinks.com'}>ThePornLinks.com</a>
          </li>
          <li>
            <a href={'https://thepornmap.com'}>The Porn Map</a>
          </li>
          <li>
            <a
              href="http://porntourist.com/?ref=aigirlfriendwtf"
              className="ptourist"
              target="_blank"
            >
              PornTourist - Best Porn Sites{' '}
              <img
                className={'inline'}
                src="https://porntourist.com/static/images/brand/i.svg"
                alt=""
              />
            </a>
          </li>
          <li>
            <a href="http://fivestarpornsites.com/" title="fivestarpornsites">
              Five Star Porn sites
            </a>
          </li>
          <li>
            <a
              href="https://theporncouch.com/aigirlfriend-wtf/"
              title="theporncouch"
            >
              The Porn Couch
            </a>
          </li>
          <li>
            <a
              href="https://menprovement.com/sex-chatbot/"
              title="sexting ai bot"
            >
              Menprovement blog{' '}
              <img
                className={'inline'}
                src="/partners/menprovement-logo.jpeg"
                alt="menprovement logo"
                width={'25'}
                height={'25'}
              />
            </a>
          </li>
          <li>
            <a
              href="https://aichatbot.pro/nsfw-ai-chatbot"
              title="NSFW ai chatbot blog"
            >
              NSFW ai chatbot blog
            </a>
          </li>
          <li>
            <a href="https://beyondaiporn.com/" title="Beyond Ai Porn">
              Beyond AI Porn
            </a>
          </li>
          <li>
            <a
              href="https://bestpremiumpornsites.com/"
              title="Best premium porn sites"
            >
              Best Premium Porn Sites
            </a>
          </li>
        </ul>
      </main>
      <h2 className="flex flex-row justify-center text-[20px]">
        Want to become a partner?
      </h2>
      <div className="container flex flex-row justify-center text-[20px]">
        Email us on contact@aigirlfriend.wtf with the subject &quot;Partnership
        Inquiry&quot;
      </div>
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
